import React, { useEffect, useRef, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Send, Users } from "lucide-react";
import { toast } from "sonner";

export default function Community() {
  const { user } = useAuth();
  const [msgs, setMsgs] = useState([]);
  const [input, setInput] = useState("");
  const scrollRef = useRef(null);

  const load = async () => {
    try {
      const { data } = await api.get("/community/messages");
      setMsgs(data);
    } catch (err) {
      console.error("Community load failed:", err);
    }
  };

  useEffect(() => {
    load();
    const iv = setInterval(load, 4000);
    return () => clearInterval(iv);
  }, []);

  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [msgs]);

  const send = async () => {
    const t = input.trim(); if (!t) return;
    setInput("");
    try { await api.post("/community/messages", { text: t }); await load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div className="container-x py-16">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center gap-3 mb-4">
          <Users className="w-5 h-5 text-[#B3FF00]" />
          <div className="eyebrow">// Community Live</div>
        </div>
        <h1 className="section-heading mb-8">Subscribers Chat</h1>

        <div className="bg-[#121217] border border-white/10 min-h-[65vh] flex flex-col">
          <div ref={scrollRef} className="flex-1 overflow-y-auto p-6 space-y-4 max-h-[65vh]" data-testid="community-messages">
            {msgs.length === 0 && (
              <div className="text-center text-white/40 py-20 font-mono-plex text-xs uppercase tracking-widest">
                No messages yet. Break the ice!
              </div>
            )}
            {msgs.map((m) => {
              const mine = m.user_id === user?.id;
              return (
                <div key={m.id} className={`flex ${mine ? "justify-end" : "justify-start"}`}>
                  <div className={`max-w-[75%] p-3 border ${mine ? "bg-[#FF5E00]/10 border-[#FF5E00]/40" : "bg-[#1C1C24] border-white/5"}`} data-testid={`community-msg-${m.id}`}>
                    <div className="text-[10px] font-mono-plex uppercase tracking-widest text-white/40 mb-1">
                      {m.user_name} · {new Date(m.created_at).toLocaleTimeString('en-US', {hour: '2-digit', minute: '2-digit'})}
                    </div>
                    <div className="text-sm">{m.text}</div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="border-t border-white/10 p-4 flex gap-2">
            <input value={input} onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && send()}
              placeholder="Type a message..."
              maxLength={500}
              className="flex-1 bg-black border border-white/10 px-4 py-3 focus:outline-none focus:border-[#B3FF00]"
              data-testid="community-input" />
            <button onClick={send} className="btn-secondary" data-testid="community-send-btn">
              <Send className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
      <div className="h-32" />
    </div>
  );
}
